export enum PaymentMethod {
  CARD = "CARD",
  PAYPAL = "PAYPAL",
  SOFORT = "SOFORT",
  TRUSTLY = "TRUSTLY",
  FPX = "FPX",
  IDEAL = "IDEAL",
  QR_CODE = "QR_CODE",
  UNKNOWN = "UNKNOWN",
}

export enum CardProvider {
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  AMERICAN_EXPRESS = "AMEX",
}
